/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_SubscriptionInputs */

const en_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Subscription`)
};

const es_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar Suscripción`)
};

const fr_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l'abonnement`)
};

const de_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement verwalten`)
};

const id_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola Langganan`)
};

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const ja_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const zh_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const ar_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const it_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const ru_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const pt_manage_subscription = en_manage_subscription;

/** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */
const ko_manage_subscription = en_manage_subscription;

/**
* | output |
* | --- |
* | "Manage Subscription" |
*
* @param {Manage_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const manage_subscription = /** @type {((inputs?: Manage_SubscriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_SubscriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_subscription(inputs)
	if (locale === "es") return es_manage_subscription(inputs)
	if (locale === "fr") return fr_manage_subscription(inputs)
	if (locale === "de") return de_manage_subscription(inputs)
	if (locale === "ja") return ja_manage_subscription(inputs)
	if (locale === "zh") return zh_manage_subscription(inputs)
	if (locale === "ar") return ar_manage_subscription(inputs)
	if (locale === "id") return id_manage_subscription(inputs)
	if (locale === "it") return it_manage_subscription(inputs)
	if (locale === "ru") return ru_manage_subscription(inputs)
	if (locale === "pt") return pt_manage_subscription(inputs)
	return ko_manage_subscription(inputs)
});